type JwtPayload = Record<string, unknown>;

function safeJsonParse(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function decodeJwtPayload(token?: string | null): JwtPayload | null {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;

  const payloadPart = parts[1];

  try {
    // Base64url decode
    const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    const parsed = safeJsonParse(json);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as JwtPayload;
  } catch {
    return null;
  }
}

function getFirstStringClaim(payload: JwtPayload, keys: string[]): string | null {
  for (const key of keys) {
    const value = payload[key];
    if (typeof value === 'string' && value.trim()) return value;
  }
  return null;
}

// Attempts to extract the user identifier from common JWT claim shapes.
export function getTokenUserId(token?: string | null): string | null {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;

  return getFirstStringClaim(payload, [
    'userId',
    'userid',
    'UserId',
    'id',
    'Id',
    'sub',
    'nameid',
    // Common .NET / WS-Fed style claim keys
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    'http://schemas.microsoft.com/identity/claims/objectidentifier',
    'oid',
  ]);
}

